export default () => {
  //This setting is only for courses with 1 Mark as Done completion
  const settingEnabled = document.querySelector(
    'body[data-tags*="mark-as-done-to-dashboard"]'
  );
  if (!settingEnabled) return;

  const mutatedParent = document.querySelector(
    '.activity:has(.activity-completion)'
  );
  if (!mutatedParent) return;

  const mutatedParentObserver = new MutationObserver(
    (mutationList, observer) => {
      const markAsDone = mutatedParent.querySelector(
        'button[data-toggletype="manual:mark-done"]'
      );
      if (markAsDone) {
        markAsDone.addEventListener('click', () => {
          window.location.href = M.cfg.wwwroot + '/my/';
        });
      }
    }
  );

  mutatedParentObserver.observe(mutatedParent, {
    childList: true,
    subtree: true,
    attributes: true
  });
};
